import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { createColor, deleteColor, getColors, updateColor } from '../../lib/api';

const ColorManagement = () => {
  const [colors, setColors] = useState([]);
  const [newColor, setNewColor] = useState({ name: '', hex_code: '#000000' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchColors();
  }, []);

  const fetchColors = async () => {
    try {
      const data = await getColors();
      setColors(data || []);
    } catch (error) {
      console.error('Error fetching colors:', error);
      toast.error('Renkleri yüklerken hata oluştu');
    }
  };

  const handleAddColor = async () => {
    if (!newColor.name.trim()) {
      toast.error('Renk adı boş olamaz');
      return;
    }

    try {
      setLoading(true);
      const data = await createColor(newColor);
      setColors((prev) => [...prev, data].sort((a, b) => a.name.localeCompare(b.name, 'tr')));
      setNewColor({ name: '', hex_code: '#000000' });
      toast.success('Renk başarıyla eklendi');
    } catch (error) {
      console.error('Error adding color:', error);
      toast.error(error.message || 'Renk eklenirken hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteColor = async (id) => {
    try {
      setLoading(true);
      await deleteColor(id);
      setColors((prev) => prev.filter((color) => color.id !== id));
      toast.success('Renk başarıyla silindi');
    } catch (error) {
      console.error('Error deleting color:', error);
      toast.error(error.message || 'Renk silinirken hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  const handleToggleVisibility = async (id, is_visible) => {
    try {
      setLoading(true);
      const updated = await updateColor(id, { is_visible });
      setColors((prev) => prev.map((color) => (color.id === id ? updated : color)));
      toast.success('Renk görünürlüğü güncellendi');
    } catch (error) {
      console.error('Error updating color visibility:', error);
      toast.error(error.message || 'Renk görünürlüğü güncellenirken hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-6">Renk Yönetimi</h1>

      <div className="bg-white p-6 rounded-lg shadow-md mb-8">
        <h2 className="text-xl font-semibold mb-4">Yeni Renk Ekle</h2>
        <div className="flex gap-4 items-end">
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 mb-1">Renk Adı</label>
            <input
              type="text"
              value={newColor.name}
              onChange={(e) => setNewColor((prev) => ({ ...prev, name: e.target.value }))}
              className="w-full px-3 py-2 border rounded-md"
              placeholder="Örn: Antrasit"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Renk Kodu</label>
            <input
              type="color"
              value={newColor.hex_code}
              onChange={(e) => setNewColor((prev) => ({ ...prev, hex_code: e.target.value }))}
              className="w-16 h-10 p-1 border rounded-md"
            />
          </div>
          <button
            onClick={handleAddColor}
            disabled={loading}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
          >
            Ekle
          </button>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-md">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Renk
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Renk Kodu
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Görünürlük
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  İşlemler
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {colors.map((color) => (
                <tr key={color.id}>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      <div
                        className="w-6 h-6 rounded-full mr-2"
                        style={{ backgroundColor: color.hex_code }}
                      />
                      {color.name}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">{color.hex_code}</td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <button
                      onClick={() => handleToggleVisibility(color.id, !color.is_visible)}
                      className={`px-3 py-1 rounded-full text-sm ${
                        color.is_visible ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                      }`}
                    >
                      {color.is_visible ? 'Görünür' : 'Gizli'}
                    </button>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <button
                      onClick={() => handleDeleteColor(color.id)}
                      className="text-red-600 hover:text-red-900"
                    >
                      Sil
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ColorManagement;
